import React from 'react'

export default () => {
  return (
    <div>
        <h2>Based on your responses, it seems like this dizziness is most likely being caused by   <strong className="text-decoration" data-tip="A type of dizziness caused by tiny crystals in the inner ear called otoconia getting lodged in the horizontal canal of the inner ear.">Horizontal-Canal Benign Paroxysmal Positional Vertigo (hc-BPPV).</strong> </h2>
        <p>Patients with hc-BPPV are usually very dizzy with their head turned to either side.</p>
        <p>Luckily, this condition can be easily treated at home without any special equipment or medicine!</p>
        <p>All you need to do is perform the Modified Gufoni Maneuver.</p>
        <a href="https://www.rehabmart.com/post/why-am-i-dizzy-top-5-causes-of-dizziness-what-to-do" target="_black">read more about this condition ></a>
    </div>
  )
}
